// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"caa5ae18","453":"be62865c","732":"f077638c"}[chunkId] + ".chunk.js";
};